import React from 'react';
import Icon from '../../../components/AppIcon';

const MemberSegmentationTable = ({ data }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-heading font-semibold text-foreground">
          Member Segmentation Analysis
        </h3>
        <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-muted hover:bg-muted/80 transition-colors">
          <Icon name="Download" size={18} />
          <span className="text-sm font-medium">Export</span>
        </button>
      </div>
      <div className="overflow-x-auto custom-scrollbar">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-4 px-4 text-sm font-semibold text-foreground">Segment</th>
              <th className="text-right py-4 px-4 text-sm font-semibold text-foreground">Members</th>
              <th className="text-right py-4 px-4 text-sm font-semibold text-foreground">Avg Revenue</th>
              <th className="text-right py-4 px-4 text-sm font-semibold text-foreground">Retention</th>
              <th className="text-right py-4 px-4 text-sm font-semibold text-foreground">Engagement</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((segment, index) => (
              <tr key={index} className="border-b border-border last:border-b-0 hover:bg-muted/50 transition-colors">
                <td className="py-4 px-4">
                  <div className="flex items-center gap-3">
                    <div 
                      className="w-3 h-3 rounded-full" 
                      style={{ backgroundColor: segment?.color }}
                    ></div>
                    <span className="text-sm font-medium text-foreground">{segment?.name}</span>
                  </div>
                </td>
                <td className="py-4 px-4 text-right">
                  <span className="text-sm text-foreground data-text">{segment?.count}</span>
                </td>
                <td className="py-4 px-4 text-right">
                  <span className="text-sm text-foreground data-text">${segment?.avgRevenue}</span>
                </td>
                <td className="py-4 px-4 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <span className="text-sm text-foreground data-text">{segment?.retention}%</span>
                    <Icon 
                      name={segment?.retentionTrend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                      size={16} 
                      color={segment?.retentionTrend === 'up' ? 'var(--color-success)' : 'var(--color-error)'}
                    />
                  </div>
                </td>
                <td className="py-4 px-4 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <div className="w-24 h-2 bg-muted rounded-full overflow-hidden">
                      <div 
                        className="h-full bg-primary rounded-full"
                        style={{ width: `${segment?.engagement}%` }}
                      ></div>
                    </div>
                    <span className="text-sm text-muted-foreground data-text">{segment?.engagement}%</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MemberSegmentationTable;